module.exports = __webpack_public_path__ + "assets/img/logo-icon.dc81ec15.svg";